module.exports = __webpack_public_path__ + "img/olu-eletu.15d2ebb3.jpg";